<template>
  <section class="blaFirstSection">
    <div class="row">
      <Header
        login-button-color="#ffffff"
        login-title="Bejelentkezés"
        login-route-name="WebApp"
      />

      <div class="col-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1">
        <div class="row">
          <div
            class="
              col-10
              offset-1
              col-md-5
              offset-md-1
              text-xs-center text-md-left
            "
          >
            <div class="blaFirstSectionTitle">
              <small>Skillers At Work</small> <br />
              Innovatív Digitális Angol Tanfolyam a munkatársai igényeire szabva
            </div>
            <p class="blaFirstSectionDescription my-4">
              Ismerje meg online nyelvi képzésünket, amely segít gyorsan és
              hatékonyan fejleszteni csapata angoltudását
            </p>
            <div
              class="clickable mt-3 blaPrimaryButton px-3 py-3"
              @click="$router.push({ name: 'registration' })"
            >
              <span class=""> Kezdés </span>
            </div>
            <!--<div-->
            <!--  class="clickable mt-3 d-none d-md-block"-->
            <!--  @click="$router.push({ name: 'WebApp' })"-->
            <!--&gt;-->
            <!--  <span class="blaPrimaryButton px-3 py-3">-->
            <!--    Kipróbálom-->
            <!--  </span>-->
            <!--</div>-->
          </div>
          <div
            class="
              col-8
              offset-2
              col-md-6
              offset-md-0
              text-xs-center text-md-right
              p-5
            "
          >
            <img
              :src="require('@/assets/img/landing_pics_md.png')"
              alt="firstSectionImg"
              class="img-fluid blaFirstSectionImgMd"
            />
            <img
              :src="require('@/assets/img/landing_pics_md.png')"
              alt="firstSectionImg"
              class="img-fluid blaFirstSectionImgHd"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
@import "../../assets/css/bla_style.css";
</style>

<script>
import Header from "@/views/public/partials/Header";
export default {
  components: { Header },
  data: () => ({}),
  methods: {},
  props: {},
  mounted: () => ({}),
};
</script>
